import React from 'react';

export const backArrow = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.5 7.5L9.5 12.5L14.5 17.5L14.5 7.5Z" fill="black" fillOpacity="0.54"/>
</svg>
